package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.moxultimate.topwithmox.appscrud.main.AppsCRUDPage
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.components.restricted.RestrictedPage
import org.moxultimate.topwithmox.core.toggle.FeatureToggle

@InitRoute
fun initAppsCRUDRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Apps CRUD"))
}

/**
 * AppsCRUDRoute
 * Renders [AppsCRUDPage] when [FeatureToggle.APP_CRUD_TOGGLE] is enabled,
 * otherwise shows [RestrictedPage].
 */
@Page(routeOverride = "apps-crud")
@Layout(".components.layouts.PageLayout")
@Composable
fun AppsCRUDRoute() {
    if (FeatureToggle.APP_CRUD_TOGGLE) AppsCRUDPage() else RestrictedPage()
}
